export default {
  header: 'Definicje parametrów aktywów',
  subheader: 'Ta strona umożliwia zarządzanie niestandardowymi parametrami zasobów, które mogą być ponownie wykorzystane w kreatorze sygnałów.',
  empty: 'Nie zdefiniowano żadnych parametrów zasobów zdefiniowanych przez użytkownika.',
  confirmDelete: {
    header: 'Löschen bestätigen',
    message: 'Du bist dabei, eine benutzerdefinierte Parametrdefinicja zu löschen. Diese Definicja wird möglicherweise von mehreren Assets verwendet.\n\nBist du sicher, dass du den Parametr "{parameter}" dauerhaft entfernen möchtest?',
  },
};
